/*
|--------------------------------------------------------------------------
| App.JS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/

import KeenSlider from '../../components/slider/slider'
import spriteRender from './core/sprite'
import menuInit from './core/menu'

window.addEventListener('DOMContentLoaded', () => {
  spriteRender('peach-pubs')
  menuInit()
})
